@let options = userOptions();

@if (options !== undefined) {
	<md-drop-down [disabled]="isReadonly()" [options]="options" [value]="selectedUserID()" [optionComponent]="userOptionComponent" (change)="changeHandler($event)"></md-drop-down>
}